var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100px","height":"100px","background-color":"#0d47a1"},on:{"click":function($event){return _vm.asd()}}},[_vm._v("\r\n    qwe\r\n")])}
var staticRenderFns = []

export { render, staticRenderFns }